import { Directive, HostListener, HostBinding, Output, EventEmitter, Input } from '@angular/core';

@Directive({
    selector: '[fileDragDrop]',
    standalone: false
})

export class FileDragNDropDirective {
  @Output() private filesChangeEmiter: EventEmitter<File[]> = new EventEmitter();
  @Output() private dragOver: EventEmitter<void> = new EventEmitter();
  @Output() private dragLeave: EventEmitter<void> = new EventEmitter();

  constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(e:any){
    e.preventDefault();
    e.stopPropagation();
    this.dragOver.emit();
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(e:any){
    e.preventDefault();
    e.stopPropagation();
    this.dragLeave.emit();
  }

  @HostListener('drop', ['$event']) public onDrop(e:any){
    e.preventDefault();
    e.stopPropagation();

    let files = e.dataTransfer.files;
    this.filesChangeEmiter.emit(Array.from(files));
  }
}
